import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";

export default function CardModal(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const style = {
    backgroundImage: "url(" + props.image + ")",
  };

  const href = `https://${props.url}`;
  return (
    <>
      <div class="block" style={style} onClick={handleShow}>
        <div class="overlay"></div>
        <div class="block--text">
          <div class="text--head">Details</div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>
            {props.title}
            <span
              onClick={handleClose}
              style={{
                cursor: "pointer",
                color: "lightgrey",
                position: "absolute",
                right: "5%",
              }}
            >
              x
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-5">
          <div className="row">
            <div className="col-md-7">
              <Carousel fade>
                {props.carousel.map((data, index) => (
                  <Carousel.Item>
                    <img
                      className="d-block w-100"
                      src={data}
                      alt="First slide"
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
            <div className="col-md-5">
              <h3 className="fw-bold">Project Info:</h3>
              <p>{props.projectInfo}</p>
              <h3 className="fw-bold mt-2">Project Details:</h3>
              <p className="border-bottom pb-2 mt-2">
                <span className="fw-bold mr-4">Client:</span>Ruby Clinton
              </p>
              <p className="border-bottom pb-2 mt-2">
                <span className="fw-bold mr-4">Industry:</span>Art & Design
              </p>
              <p className="border-bottom pb-2 mt-2">
                <span className="fw-bold mr-4">Technologies:</span>iOS, HTML5,
                CSS3, PHP, Java
              </p>
              <p className="border-bottom pb-2 mt-2">
                <span className="fw-bold mr-4">Industry:</span>July 16, 2020
              </p>
              {props.url.length > 0 ? (
                <p className="border-bottom pb-2 mt-2">
                  <span className="fw-bold mr-4">URL:</span>{" "}
                  <a
                    className="rounded-0 p-2"
                    href={href}
                    style={{
                      textDecoration: "none",
                      color: "black",
                      cursor: "pointer",
                      backgroundColor: "#f5df4e",
                    }}
                  >
                    {props.url}
                  </a>{" "}
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
